export const parsePdiCmsData = ({ data }) => {
    const { seo = {}, breadcrumb = {}, pageSections = [], carTypeList = [] } =
    data || {};

    return {
        cmsData: {
            seo,
            breadcrumb,
            pageSections,
            carTypeList
        }
    };
};
